<div class="header">
  <div class="appImage">
    <a href="#">
      <img src="./assets/images/CalOptima Logo - Provider Portal Reverse.png" class="logo img-responsive" alt="logo" />
    </a>
  </div>
</div>
